<template>
  <div class="step2">
    <div class="tishi">
      <div class="intro-student">
        <img src="@/assets/images/step/pic2.jpg"
             class="fl">
        <div class="fl">
          <p>姓&#12288;&#12288;名：15735346353</p>
          <p>性&#12288;&#12288;别：***</p>
          <p>准考证号：11111111</p>
          <p>证件号码：11111111111111111</p>
        </div>
      </div>
      <div class="time fr">
        <timer :end-times.sync="endTimes"
               description="离考试开始还有"
               @submit="examStart" />&nbsp;
        <a href="javascript:void (0);"
           @click="examStart">马上做题</a>
      </div>
      <div class="clear" />
      <h3><img src="@/assets/images/step/title.gif"></h3>
      <div class="tex_warp">
        <div class="tex">
          <div v-show="showInfo"
               class="mk">
            <div class="con">
              <iframe scrolling="auto"
                      frameborder="0"
                      marginwidth="10"
                      marginheight="10"
                      src="//www.chinaacc.com/zhongjizhicheng/zhuanti/wzhxt/ksxz/"
                      height="100%"
                      width="100%" />
            </div>
          </div>
          <div class="mk"
               v-show="!showInfo">
            <div class="con">
              <iframe scrolling="auto"
                      frameborder="0"
                      marginwidth="10"
                      marginheight="10"
                      src="//www.chinaacc.com/zhongjizhicheng/zhuanti/wzhxt/czsm/"
                      height="100%"
                      width="100%" />
            </div>
          </div>
        </div>
        <div class="btn">
          <a href="javascript:void(0);"
             @click="change(0)"
             class="a1"
             target="_self">考生须知</a>
          <a href="javascript:void(0);"
             @click="change(1);"
             class="a1"
             target="_self">操作说明</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPwcExamInfo} from '@api/activity'
import { setPageTitle, parseNumber, getCookie } from '@/utils'
import { Timer } from '@components/exam'
export default {
  name: 'pwcStep2',
  components: {
    Timer,
  },
  data() {
    return {
      flag: 'activitySimPaper',
      showInfo: true,
      endTimes: 120, // 单位秒
      activityExamID: '',
      userID: '',
      zkzID: '11111111111',
      personID: '111111111111111111',
      tipInfo: null,
      isNext: false, // 所有的判断完毕才能进行下一步
    }
  },
  async mounted() {
    const { activityExamID, flag } = this.$route.query
    this.activityExamID = activityExamID
      ? parseNumber(activityExamID)
      : activityExamID
    this.flag = flag
    this.userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
    this.init()
  },
  methods: {
    init() {
      let params = {
        activityExamID: this.activityExamID,
        userID: this.userID,
      }
      getPwcExamInfo(params)
        .then((res) => {
          // 考试提醒
          if (res) {
            document.title = setPageTitle(res.courseName || '会计专业技术考试')
            this.tipInfo = res
            // isExamDate是否在考试时间  0-未在考试时间   1-在考试时间
            if (res.isExamDate === 0) {
              // this.$message.warning('未在考试时间')
              alert('未在考试时间')
              // 关闭当前页
              // window.location.href = 'about:blank'
              // window.close()
              // 点击关闭，跳转课程列表页
              window.location.href = '//member.chinaacc.com/homes/mycourse'
            } else if (res.isExamDate === 1) {
              // isExceedNum是否超过做题次数  0-超过做题次数  1-未超过做题次数
              if (res.num != -1) {
                if (res.isExceedNum === 0) {
                  // this.$message.warning('您已超过做题次数')
                  alert('您已超过做题次数')
                  // 关闭当前页
                  // window.location.href = 'about:blank'
                  // window.close()
                  // 点击关闭，跳转课程列表页
                  window.location.href = '//member.chinaacc.com/homes/mycourse'
                } else if (res.isExceedNum === 1) {
                  this.isNext = true
                }
              } else {
                this.isNext = true
              }
            }
          }
        })
        .catch((e) => {
          this.$message.error(e && e.msg)
        })
    },
    change(type) {
      if (type === 0) {
        this.showInfo = true
      } else if (type === 1) {
        this.showInfo = false
      }
    },
    examStart() {
      if (!this.isNext) {
        this.$message.warning('未查询到模考信息')
        return
      }
      this.$router.push({
        path: `/activity/pwc/ordinaryExam`,
        query: {
          activityExamID: this.activityExamID,
          flag: this.flag,
        },
      })
      // let params = {
      //   flag: this.flag,
      //   activityExamID: this.activityExamID,
      //   userID: this.userID,
      // }
      // 查询是否有临时保存试题
      // checkTempActivityExamPaper(params).then((res) => {
      //   if (res.length > 0) {
      //     const tempData = res[0]
      //     // let _confirm = confirm(
      //     //   '请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷'
      //     // )
      //     // if (_confirm) {
      //       return this.$router.push({
      //         path: '/activity/pwc/ordinaryExam',
      //         query: {
      //           flag: this.flag,
      //           activityExamID: this.activityExamID,
      //           bizID: String(tempData.bizID),
      //           spendTime: String(tempData.spendTime),
      //           temp: '2',
      //         },
      //       })
      //     // } else {
      //     //   return this.$router.push({
      //     //     path: '/activity/pwc/ordinaryExam',
      //     //     query: {
      //     //       flag: this.flag,
      //     //       activityExamID: this.activityExamID,
      //     //       spendTime: 0,
      //     //       temp: '1',
      //     //       includeTempButAbandon: '1',
      //     //     },
      //     //   })
      //     // }
      //   }
      //   return this.$router.push({
      //     path: '/activity/pwc/ordinaryExam',
      //     query: {
      //       flag: this.flag,
      //       activityExamID: this.activityExamID,
      //       temp: '1',
      //     },
      //   })
      // })
    },
  },
}
</script>
<style lang="scss">
</style>
